import { Card, CardHeader, CardTitle, ImageContainer } from '@/components'

import { Evidencia } from '../entities/evidencia'

export function EvidenciasCard({ evidencias }: { evidencias: Evidencia[] }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Evidências</CardTitle>
      </CardHeader>

      <div className="flex items-center gap-2 overflow-auto">
        {evidencias.length === 0 && (
          <p className="text-muted-foreground">Nenhuma evidência encontrada</p>
        )}
        {evidencias.map((evidencia) => (
          <div
            key={evidencia.id}
            className="flex size-40 min-w-40 items-center justify-center overflow-hidden rounded-xl border border-muted-foreground/20 bg-white"
          >
            <ImageContainer src={evidencia.url} />
          </div>
        ))}
      </div>
    </Card>
  )
}
